import { createContext, PropsWithChildren, useCallback, useContext } from "react";
import { api } from "../../contracts";
import { Auth } from "../../contracts/auth/dto";

type MeContextData = {
    getMe: () => Promise<Auth>
};

const DEFAULT: MeContextData = {
    getMe: () => Promise.resolve({} as Auth)
};

const MeContext = createContext(DEFAULT);

export const MeProvider = ({ children }: PropsWithChildren<any>) => {

    const getMe = useCallback(async () => {
        return await api.me.getInfoUser();
    }, [])

    return <MeContext.Provider
        value={{
            getMe
        }}>
        {children}
    </MeContext.Provider>
}

export function useMe(): MeContextData {
    const context = useContext(MeContext);

    if (!context) {
        throw new Error('useAuth must be used within an AuthProvider');
    }

    return context;
}